import React from 'react'
import exportFromJSON from 'export-from-json';

function DownloadCsv({csvData}){

    // Download csv data
    const exportType = 'csv'
    let fileName = `CONSULTANT_DATA`

    const downloadCSV = async() => {
        const data = csvData
        exportFromJSON({ data, fileName, exportType });
      };

    return(
        <div>
           <button className="btn btn-primary btn-block" onClick={downloadCSV} >
                Download csv
            </button>
        </div>
    )
}

export default DownloadCsv